<template>
  <div class="rounded">
    <h5 class="bg-light text-center rounded py-2 mb-0 font-bold">
      محصولات
    </h5>
    <b-table hover bordered responsive :items="order.items" :fields="fields">
      <template v-slot:cell(id)="data">
        {{ data.item.id }}
      </template>
      <template v-slot:cell(product)="data">
        <router-link
          :to="'/admin/products/edit/' + data.item.product.id"
          v-if="data.item.product"
        >
          <h6>{{ data.item.product.title }}</h6>
        </router-link>
      </template>
      <template v-slot:cell(single_price_without_discount)="data">
        {{ data.item.showcase.single_price_without_discount | price }}
      </template>
      <template v-slot:cell(total_price_without_discount)="data">
        {{ data.item.showcase.total_price_without_discount | price }}
      </template>
      <template v-slot:cell(single_discount)="data">
        <span v-if="data.item.showcase.single_discount">{{
          data.item.showcase.single_discount | price
        }}</span>
        <span v-else>ندارد</span>
      </template>
      <template v-slot:cell(total_discount)="data">
        <span v-if="data.item.showcase.total_discount">{{
          data.item.showcase.total_discount | price
        }}</span>
        <span v-else>ندارد</span>
      </template>
      <template v-slot:cell(total_price_sold)="data">
        {{ data.item.showcase.total_price_sold | price }}
      </template>
      <template v-slot:cell(total_quantity)="data">
        {{ data.item.showcase.total_quantity }}
      </template>
    </b-table>
    <div
      class="price-box mt-5 col-md-3 mx-auto"
      style="flex: 0 0 28%;max-width: 28%;"
    >
      <div class="d-md-flex justify-content-between">
        <span class=" px-3 py-2 font-bold">
          مجموع قیمت های کالا
        </span>
        <span class=" px-3 py-2">
          {{
            order.showcase.total_products_prices_without_discount | price
          }}
          تومان
        </span>
      </div>
      <div class="d-md-flex justify-content-between">
        <span class=" px-3 py-2 font-bold">
          هزینه ارسال
        </span>
        <span v-if="order.shipping_amount" class=" px-3 py-2">
          {{ order.shipping_amount | price }} تومان
        </span>
        <span v-else class=" px-3 py-2">
          0
        </span>
      </div>
      <div class="d-md-flex justify-content-between">
        <span class=" px-3 py-2 font-bold">
          تخفیف
        </span>
        <span v-if="order.showcase.discount_on_products" class=" px-3 py-2">
          {{ order.showcase.discount_on_products | price }} تومان
        </span>
        <span v-else class=" px-3 py-2">
          ندارد
        </span>
      </div>

      <div class="d-md-flex justify-content-between">
        <span class=" px-3 py-2 font-bold">
          پرداخت نهایی
        </span>
        <span class=" px-3 py-2">
          {{ order.showcase.payable_price | price }} تومان
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import OrderItemsImpl from "@@/core/components/order/OrderItems/OrderItemsImpl";

export default {
  name: "OrderItems",
  extends: OrderItemsImpl,
};
</script>

<style scoped>
.price-box {
  box-shadow: 0 0 5px -3px #133e9e;
  border-radius: 6px;
}

.order-product-img {
  max-width: 100px;
}
</style>
